import { Box, Card } from '@mui/material'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import WTypography from 'Components/whiteTypography'
import { Radar } from 'react-chartjs-2'
import CustomButton from 'Components/CustomButton/CustomButton'
import QuestionMarkIcon from '@mui/icons-material/QuestionMark'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import QuestionAnswerForm from './QuestionAnswerForm'

const options = {
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: 30,
  },
  scales: {
    r: {
      pointLabels: {
        color: 'white',
        display: true,
        centerPointLabels: true,
        font: {
          size: 14,
        },
        callback: (label) => {
          const maxLength = 15
          const words = label.split(' ')
          const lines = []
          let currentLine = ''

          for (const word of words) {
            if ((currentLine + ' ' + word).trim().length <= maxLength) {
              currentLine += ` ${word}`
            } else {
              lines.push(currentLine.trim())
              currentLine = word
            }
          }

          if (currentLine) {
            lines.push(currentLine.trim())
          }

          return lines
        },
      },
      grid: {
        color: 'gray',
        lineWidth: 1,
      },
      angleLines: {
        color: 'gray',
      },
      suggestedMin: 0,

      ticks: {
        display: true,
        color: 'black',
      },
    },
  },
  plugins: {
    datalabels: {
      display: false,
    },
    legend: {
      display: false,
      position: 'top',
    },
  },
}
function SoftSkills({ oldData, updateReports }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [open, setOpen] = useState(false)
  const location = useLocation()

  const [data, setRevData] = useState({
    labels: ['Eating', 'Drinking', 'Sleeping', 'Designing', 'Coding', 'Cycling', 'Running'],
    datasets: [
      {
        data: [65, 59, 90, 81, 56, 55, 40],
        fill: true,
        borderColor: '#c1daf1',
        pointBackgroundColor: '#c1daf1',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: '#c1daf1',
      },
    ],
  })
  useEffect(() => {
    setRevData({
      labels: oldData.label,
      datasets: [
        {
          data: oldData.data,
          fill: true,
          borderColor: '#c1daf1',
          pointBackgroundColor: '#c1daf1',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: '#c1daf1',
        },
      ],
    })
  }, [oldData])

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const shouldOpenSoftSkills =
      location.pathname === '/professionnelle/soft-skills' ||
      params.get('questionnaire') === 'soft-skills' ||
      location.hash === '#soft-skills'

    if (shouldOpenSoftSkills) {
      setOpen(true)
    }
  }, [location.hash, location.pathname, location.search])

  return (
    <>
      <Card className="dashboard_card__root1" sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box className="dashboard_card__header1 no-drag">
          <WTypography component={'span'} variant="h6">
            {t('professionnelle.softSkills') /* LAP-733 (GE022) */}
          </WTypography>
          {oldData.show && (
            <WTypography component={'span'} variant="h6">
              {oldData.total_score}
            </WTypography>
          )}
        </Box>
        {oldData.show && (
          <Box className="dashboard_card__header1">
            <WTypography sx={{ color: '#ffffffa1' }} variant={'body2'}>
              {t('professionnelle.softSkillsScore') /* LAP-733 (GE022) */}
            </WTypography>
          </Box>
        )}
        {oldData.show ? (
          <>
            <Box mt={1} minWidth={3} mb={0} height={'100%'}>
              <Radar data={data} options={options} />
            </Box>

            <Box
              mt={0}
              className="dashboard_card__filters no-drag"
              sx={{ position: 'unset !important', width: '100%', pr: '0px !important' }}
            >
              <QuestionAnswerForm
                open={open}
                setOpen={setOpen}
                startIcon={
                  <CustomButton style={{ padding: '0 5px' }}>
                    {t('professionnelle.btnReevaluerSoftSkills') /* LAP-733 (GE022) */}
                  </CustomButton>
                }
                updateReports={updateReports}
              />
            </Box>
          </>
        ) : (
          <Box mt={1} minWidth={3} mb={0} height={'100%'}>
            <Box
              className="no-drag"
              height={'100%'}
              justifyContent={'center'}
              color={'white'}
              display={'flex'}
              flexDirection={'column'}
              alignItems={'center'}
            >
              <QuestionAnswerForm
                open={open}
                setOpen={setOpen}
                startIcon={
                  <Box
                    sx={{
                      width: 172,
                      height: 172,
                      borderRadius: 4,
                      display: 'grid',
                      placeItems: 'center',
                      color: '#ffffff',
                      bgcolor: 'rgba(255, 255, 255, 0.08)',
                      border: '1px solid rgba(255, 255, 255, 0.16)',
                      boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.16)',
                      mb: 3,
                      transition: 'transform 160ms ease, background-color 160ms ease',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        bgcolor: 'rgba(255, 255, 255, 0.13)',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: 104,
                        height: 104,
                        borderRadius: '50%',
                        display: 'grid',
                        placeItems: 'center',
                        bgcolor: '#ffffff',
                        color: '#00295f',
                      }}
                    >
                      <QuestionMarkIcon sx={{ fontSize: '56px' }} />
                    </Box>
                  </Box>
                }
                updateReports={updateReports}
              />

              <Box
                sx={{
                  px: 2,
                  fontWeight: 800,
                  fontSize: 17,
                  textAlign: 'center',
                  lineHeight: 1.25,
                }}
              >
                {t('professionnelle.softSkillsTest') /* LAP-733 (GE022) */}
              </Box>
              <Box
                sx={{
                  mt: 1.5,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.75,
                  color: '#c1daf1',
                  fontSize: 13,
                  fontWeight: 700,
                }}
              >
                {t('professionnelle.softSkillsOpenQuestionnaire') /* LAP-733 (GE022) */} <ArrowForwardIcon sx={{ fontSize: 16 }} />
              </Box>
            </Box>
          </Box>
        )}
      </Card>
    </>
  )
}

export default SoftSkills
